/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-blue[_ngcontent-%COMP%]{color:#fff;background-color:#1b76bb}.btn[_ngcontent-%COMP%]{font-weight:500;font-size:16px;border-radius:25px;padding:8px 24px;border:none}.form-control[_ngcontent-%COMP%]{height:48px;margin-top:8px;margin-bottom:8px;border-radius:10px}.alert-secondary[_ngcontent-%COMP%]{color:#383d41;background-color:#fff;border-color:#dc3545}.text-blue[_ngcontent-%COMP%]{color:#1b76bb!important}"];
export { styles as styles };
